"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _UIModalDialog = _interopRequireDefault(require("./UIModalDialog"));

var _decorators = require("../utils/propTypes/decorators");

var PanelContext = _interopRequireWildcard(require("../context/PanelContext"));

var _ModalPanelTransition = _interopRequireDefault(require("./internal/ModalPanelTransition"));

var _AbstractModal = _interopRequireDefault(require("./internal/AbstractModal"));

var _Functions = require("../core/Functions");

var _BrowserTest = require("../utils/BrowserTest");

var _DropdownContext = require("../context/DropdownContext");

var inPanelContext = {
  inPanel: true
};

var UIModalPanel = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UIModalPanel, _PureComponent);

  function UIModalPanel() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIModalPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIModalPanel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleOpenComplete = function () {
      var onOpenComplete = _this.props.onOpenComplete;
      (0, _Functions.callIfPossible)(onOpenComplete);

      if ((0, _BrowserTest.isSafari)()) {
        _this._autoFocusedEl.focus();
      }
    };

    return _this;
  }

  (0, _createClass2.default)(UIModalPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Safari glitches the transition if an element in the modal panel is focused (#6033)
      if ((0, _BrowserTest.isSafari)()) {
        this._autoFocusedEl = document.activeElement;

        this._autoFocusedEl.blur();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var shouldLogModalWarning = this.context.shouldLogModalWarning,
          _this$props = this.props,
          __panelKey = _this$props.panelKey,
          width = _this$props.width,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["panelKey", "width"]);

      var _createPlacementWarning = (0, _DropdownContext.createPlacementWarning)(UIModalPanel.displayName);

      if (shouldLogModalWarning) {
        _createPlacementWarning();
      }

      return _react.default.createElement(PanelContext.Provider, {
        value: inPanelContext
      }, _react.default.createElement(_AbstractModal.default, Object.assign({}, rest, {
        _use: "sidebar",
        _dialogWidth: width,
        componentName: "UIModalPanel",
        Transition: _ModalPanelTransition.default,
        onOpenComplete: this.handleOpenComplete
      })));
    }
  }]);
  return UIModalPanel;
}(_react.PureComponent);

UIModalPanel.propTypes = Object.assign({}, (0, _omit.default)(_UIModalDialog.default.propTypes, ['centered', 'size', 'use']), {
  onCloseComplete: _propTypes.default.func,
  onCloseStart: _propTypes.default.func,
  onOpenComplete: _propTypes.default.func,
  onOpenStart: _propTypes.default.func,
  panelKey: (0, _decorators.hidden)(_propTypes.default.string),
  _contextual: _propTypes.default.bool
});
UIModalPanel.defaultProps = {
  width: 700,
  _contextual: false
};
UIModalPanel.displayName = 'UIModalPanel';
UIModalPanel.contextType = _DropdownContext.DropdownContext;
var _default = UIModalPanel;
exports.default = _default;
module.exports = exports.default;